export default __webpack_public_path__ + "static/media/img3.d1f411ff.jpg";